import React, { useRef, useEffect } from 'react';
import debounce from 'lodash/debounce';
import styled from 'styled-components/macro';

import ToolbarOptions from './ToolbarOptions';
import { useAppContext, useNavigation } from '../../context';

const Wrapper = styled.section`
    background-color: white;
    flex-direction: row;
    display: flex;
    padding-top: 8px;
    padding-bottom: 2px;
    gap: 2px;
`;

const DesktopWorkspaceTools = () => {
    const { isMobile, smallHeightDevice } = useAppContext();
    const { setToolbarHeight } = useNavigation();

    const wrapperRef = useRef(null);
    useEffect(() => {
        const debouncedSetToolbarHeight = debounce((height) => {
            setToolbarHeight(height);
        }, 100);

        const observer = new ResizeObserver((entries) => {
            if (entries[0] && entries[0].borderBoxSize && entries[0].borderBoxSize[0]) {
                const { blockSize } = entries[0].borderBoxSize[0];
                debouncedSetToolbarHeight(blockSize);
            }
        });
        if (wrapperRef.current) {
            observer.observe(wrapperRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [setToolbarHeight, isMobile, smallHeightDevice]);

    return (
        <Wrapper ref={wrapperRef}>
            <ToolbarOptions/>
        </Wrapper>
    );
};

export default DesktopWorkspaceTools;
